import { emptySpinButtonLabel } from '../components/RoomFilter/CapabilityFilters.locstring.json';
import { FeatureFilterItemType } from '../components/RoomFilter/FeatureFilterItemType';
import getStore from '../store/store';
import loc from 'owa-localize';
import { mutatorAction } from 'satcheljs';
import CapabilityFilter, {
    CapabilityFilterType,
} from '../components/RoomFilter/CapabilityFilterType';

export const clearFilters = mutatorAction('clearFilters', () => {
    const store = getStore().roomFilterState;
    store.expandCapacity = false;
    store.expandFeature = false;
    store.expandFloor = false;
    store.selectedCapacity = null;
    store.selectedFeatures = [];
    store.selectedTags = [];
    store.selectedFloor = null;
    store.selectedFilters = null;
    store.shouldGetSpaces = false;
});

export const updateCapacityExpandation = mutatorAction('updateCapacityExpandation', () => {
    getStore().roomFilterState.expandCapacity = !getStore().roomFilterState.expandCapacity;
});

export const updateFeatureExpandation = mutatorAction('updateFeatureExpandation', () => {
    getStore().roomFilterState.expandFeature = !getStore().roomFilterState.expandFeature;
});

export const updateFloorExpandation = mutatorAction('updateFloorExpandation', () => {
    getStore().roomFilterState.expandFloor = !getStore().roomFilterState.expandFloor;
});

export const updateCapacityValue = mutatorAction(
    'updateCapacityValue',
    (selectedCapacity: string) => {
        getStore().roomFilterState.selectedCapacity =
            selectedCapacity === loc(emptySpinButtonLabel) ? null : selectedCapacity;
    }
);

export const updateFeaturesValue = mutatorAction(
    'updateFeaturesValue',
    (selectedFeatures: FeatureFilterItemType[]) => {
        getStore().roomFilterState.selectedFeatures = selectedFeatures;
    }
);

export const updateTagsValue = mutatorAction('updateTagsValue', (selectedTags: string[]) => {
    getStore().roomFilterState.selectedTags = selectedTags;
});

export const updateFloorValue = mutatorAction('updateFloorValue', (selectedFloor: string) => {
    getStore().roomFilterState.selectedFloor =
        selectedFloor == loc(emptySpinButtonLabel) ? null : selectedFloor;
});

export const updateSelectedFilters = mutatorAction('updateSelectedFilters', () => {
    const selectedFilters = [];
    const {
        selectedCapacity,
        selectedFeatures,
        selectedFloor,
        selectedTags,
    } = getStore().roomFilterState;
    if (selectedCapacity) {
        const capacityFilter: CapabilityFilter = {
            filterName: CapabilityFilterType.Capacity,
            filterValue: selectedCapacity,
        };
        selectedFilters.push(capacityFilter);
    }
    if (selectedFeatures && selectedFeatures.length != 0) {
        const featuresFilter: CapabilityFilter = {
            filterName: CapabilityFilterType.Feature,
            filterValue: selectedFeatures,
        };
        selectedFilters.push(featuresFilter);
    }
    if (selectedFloor) {
        const floorFilter: CapabilityFilter = {
            filterName: CapabilityFilterType.Floor,
            filterValue: selectedFloor,
        };
        selectedFilters.push(floorFilter);
    }
    if (selectedTags) {
        const tagsFilter: CapabilityFilter = {
            filterName: CapabilityFilterType.Tag,
            filterValue: selectedTags,
        };
        selectedFilters.push(tagsFilter);
    }
    getStore().roomFilterState.selectedFilters = selectedFilters;
});

export const updateShouldGetSpaces = mutatorAction(
    'updateShouldGetSpaces',
    (shouldGetSpaces: boolean) => {
        getStore().roomFilterState.shouldGetSpaces = shouldGetSpaces;
    }
);
